import React from "react";

const RoundedCardComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default RoundedCardComponent;
